import React from 'react';
import PropTypes from 'prop-types';

import useFormatter from 'src/hooks/useFormatter';

const MoneyValueCustomCurrency = ({ className, value }) => {
  const { currencyFormatter } = useFormatter();

  const html = currencyFormatter
    .format(value, { minimumFractionDigits: 2 })
    .replace(/([^\d.,\s]+)/g, '<span class="currency-symbol" />$1</span>');

  return <span className={className} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default MoneyValueCustomCurrency;

MoneyValueCustomCurrency.propTypes = {
  className: PropTypes.string,
  dataId: PropTypes.string,
  value: PropTypes.number,
};
